<template>
    <div class="bigbox">
        <Heads :breadData="breadData"></Heads>
        <div class="bigbox_main">
            <Lft @getbreadcrumb="getArr"></Lft>
            <div class="frame">
                <div class="loading" v-if="$api.loading">
                    <div>
                        <Icon type="load-d" class="loading_icon"></Icon>
                    </div>
                </div>
                <div id="container">
                    <div class="scroll-div">
                        <keep-alive>
                            <router-view v-if="$route.meta.keepAlive"></router-view>
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive"></router-view>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
    import Lft from "@/components/left";
    import Heads from "@/components/header";
    export default {
        data() {
            return {
                breadData: ['个人工作台'],
                loading:this.$api
            }
        },
        methods: {
            getArr(data) {
                this.breadData = null;
                this.breadData = data;
            }
        },
        mounted() {},
        components: {
            Lft,
            Heads
        },
    }
</script>
<style lang="">
    .loading {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1000;
        background: rgba(255, 255, 255, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loading_icon {
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        color:#ec6d2a;
        font-size: 30px;
        transform: rotate(360deg);
        transform-origin: 50% 50%;
        animation: rotate 1.5s infinite linear;
    }
    @keyframes rotate {
        0%{
            transform: rotate(0deg)
        }
        100%{
            transform: rotate(360deg)
        }
    }
    .bigbox {
        width: 100%;
        height: 100%;
    }
    .bigbox_main {
        width: 100%;
        min-width: 1440px;
        height: calc(100% - 99px);
        background: #f5f7f9;
    }
    .frame {
        float: left;
        width: calc(100% - 192px);
        background: #f5f7f9;
        height: 100%;
        overflow-y: auto;
        position: relative;
    }
    
    #container {
        width: 100%;
        height: calc(100% - 36px);
        padding: 16px 16px 0 16px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .scroll-div {
        width: 100%;
        height: 100%;
        padding-bottom: 80px;
        position: relative;
    }
    .ivu-breadcrumb {
        color: #333;
        font-size: 14px;
    }
    .ivu-breadcrumb>span:last-child ,.ivu-breadcrumb>span:nth-last-child(2) .ivu-breadcrumb-item-separator{
        font-size: 18px;
        font-weight: 700;
        color: #495060;
    }
</style>


// WEBPACK FOOTER //
// src/components/homeMain/home/index.vue